import { useState } from "react";
import axios from "axios";
import BASE_URL from "../constants/baseUrls";

const useAirlineList = () => {
    const [airlines, setAirlines] = useState([]);
    const [isAirlineLoading, setIsAirlineLoading] = useState(false);

    const getAirlines = async () => {
        try {
            setIsAirlineLoading(true);
            const response = await axios.get(`${BASE_URL}/api/v2/basic/airline/list`);
            const airlinesList = response.data.data.results;
            setAirlines(airlinesList);
            return airlinesList;
        } catch (error) {
            console.error("Error fetching airline list:", error);
        } finally {
            setIsAirlineLoading(false);
        }
    };

    return { airlines, isAirlineLoading, getAirlines };
};

export default useAirlineList;
